import { useState } from "react";
import ReactCrop from "react-image-crop";
import image_placeholder from "../../image/imagem-placeholder.jpg";
import { ModalPopUp } from "../ModalPopUp";
import { IconAddImage, IconSave, IconTrash } from "../../icons";
import { Toaster } from "react-hot-toast";
import { toastError, toastSuccess } from "../Toast";
import "react-image-crop/dist/ReactCrop.css";
import "./index.scss";

export function UploadImage({ img = image_placeholder, setImage: uploadImage, className = "", handleDeleteImage }) {
  const [imagemOfClient, setImagemOfClient] = useState(img);
  const [image, setImage] = useState(null);
  const [viewImage, setViewImage] = useState("");
  const [src, setSrc] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [result, setResult] = useState(null);
  const [crop, setCrop] = useState<any>({ aspect: 9 / 9 });
  const [clickDeleteImage, setClickDeleteImage] = useState(false);

  const handleFileChange = (e: any) => {
    if (!e?.target?.files[0]) return;
    const isNotFileImage = !e?.target?.files[0]?.type.includes("image/");
    if (isNotFileImage) return toastError("Esse arquivo não é do tipo Imagem!");
    setSrc(URL?.createObjectURL(e.target.files[0]));
    setImage(e.target.files[0]);
  };

  function getCroppedImg() {
    if (!image) return;

    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;

    const ctx = canvas.getContext("2d");

    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);

    canvas?.toBlob((blob) => {
      setResult(blob);
    });
  }

  function handleStateModal() {
    setStatusModal((oldStatus) => !oldStatus);
  }

  function SaveImageModal() {
    function handleClickSave() {
      setModalEdit(false);
      handleStateModal();
      uploadImage(result || imagemOfClient);
      setViewImage(result ? URL?.createObjectURL(result) : imagemOfClient);
      if (clickDeleteImage) handleDeleteImage();
    }

    return (
      <button onClick={() => handleClickSave()} type="button" className="button-cropper-save center pointer image-contrast font-poppins gap">
        {imagemOfClient ? "Salvar" : "Salvar Corte"} {IconSave}
      </button>
    );
  }

  function SaveDisabled() {
    return (
      <button
        type="button"
        disabled={true}
        className="button-cropper-save-blocked bg-gray-500 font-poppins font-bold text-white w-200px rounded-md center cursor-not-allowed font-poppins gap image-contrast"
      >
        Salvar <span>{IconSave}</span>
      </button>
    );
  }

  function clearValuesImage() {
    setImage(null);
    setResult(null);
    uploadImage("");
    setSrc("");
    setViewImage("");
    setImagemOfClient(image_placeholder);
    setClickDeleteImage(true);
  }

  function DeleteButton() {
    return (
      <button type="button" className="button-cropper button-remove-image" onClick={() => clearValuesImage()}>
        {IconTrash}
      </button>
    );
  }

  return (
    <>
      <Toaster />
      <ModalPopUp className="modal-image-client" title="Editar imagem" status={statusModal} onClickCancel={handleStateModal}>
        {imagemOfClient && !src ? (
          <div className="flex justify-center">
            <img src={imagemOfClient} className="" width="150px" height="150px" />
          </div>
        ) : src ? (
          <div className="box-row around mx-2">
            <div onTouchMoveCapture={getCroppedImg} onMouseMoveCapture={getCroppedImg} className="flex">
              <ReactCrop
                src={src}
                onImageLoaded={setImage}
                imageStyle={{ maxHeight: 300, maxWidth: 300 }}
                crop={crop}
                onChange={setCrop}
                minWidth={75}
                minHeight={75}
                style={{ display: "flex", justifyContent: "space-around", flexDirection: "row", cursor: "crosshair" }}
                circularCrop={true}
              />
            </div>
            {!result ? (
              <p className="flex justify-center items-center w-1/3 text-4xl text-center">
                Para salvar, recorte a imagem ao lado em formato de círcular.
              </p>
            ) : (
              ""
            )}
            {result && (
              <div className="flex items-center">
                <img src={URL.createObjectURL(result)} alt="Image" width="200" height="200" className="border-radius-50p100" />
              </div>
            )}
          </div>
        ) : (
          <div className="flex justify-center">
            <img src={image_placeholder} width="150px" height="150px" className="image-placeholder-modal" />
          </div>
        )}
        <div className={`box-row m-top10 between ${imagemOfClient && "between"}`}>
          <label className="label-input-file flex center input-type-file bg-primary pointer radius-5px font-poppins">
            <span className="image-contrast gap center align-text-center">
              {" "}
              {imagemOfClient || viewImage ? "Trocar Imagem" : "Adicionar Imagem"} {IconAddImage}
            </span>
            <input
              type="file"
              name="image"
              className="borda"
              onChange={(e) => {
                handleFileChange(e);
                setResult(null);
              }}
              accept=".png, .jpg, .jpeg"
            />
          </label>
          <DeleteButton />
          {result ? <SaveImageModal /> : <SaveDisabled />}
        </div>
      </ModalPopUp>
      <div>
        {modalEdit ? (
          <div>
            <button type="button">Save</button>
          </div>
        ) : (
          <>
            {imagemOfClient ? (
              <label className={`input-type-file pointer ${className}`}>
                <img
                  src={viewImage || imagemOfClient}
                  onClick={handleStateModal}
                  width="80px"
                  height="80px"
                  className="border-radius-50p100 margin-10"
                />
              </label>
            ) : (
              <label className={`input-type-file pointer ${className}`}>
                <img
                  onClick={handleStateModal}
                  src={viewImage || image_placeholder}
                  alt="Image"
                  width="80px"
                  height="80px"
                  className="border-radius-50p100"
                />
              </label>
            )}
          </>
        )}
      </div>
    </>
  );
}
